import { makeStyles } from "tss-react/mui";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Card, DialogActions, Grid } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiDatePicker from "components/SuiDatePicker";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import DropZone from "components/UpStyled/DropZone";
import { nanoid } from "nanoid";
import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import api from "services/api";
import { AccountContext } from "context/account";
import Paper from "@mui/material/Paper";
import SuiSelect from "components/SuiSelect";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import CreateResponseTemplatePrompt from "pages/setting/components/CreateResponseTemplatePrompt";

const useStyles = makeStyles({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

const SendQuoteMessage = ({ selectedProject, setChatRoomId, chatroomId }) => {
  const classes = useStyles();
  var defaultmsg = "I'm interested in your project!";
  const [quoteMessage, setQuoteMessage] = useState(defaultmsg);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [additionalCost, setAdditionalCost] = useState(null);
  const [quotePrice, setQuotePrice] = useState("TBD");
  const [styleCost, setStyleCost] = useState({}); //unitCost, patternMakingCost, sampleCost, preProductionCost
  const [uploadFiles, setUploadFiles] = useState([]);
  const [editMessage, setEditMessage] = useState(false);
  const [templateMenuVisible, setTemplateMenuVisible] = useState();
  const [createTemplateVisible, setCreateTemplateVisible] = useState(false);

  const { id, metadata, handleUpdate } = useContext(AccountContext);
  let responseTemplates = metadata?.project_response_template || [];

  useEffect(() => {
    var initdata = {};
    for (var product of selectedProject.products) {
      initdata[product.title] = {
        quantity: product.style.quantity ? product.style.quantity : "0",
        unitCost: "",
        patternMakingCost: "",
        sampleCost: "",
        preProductionCost: "",
      };
    }
    setStyleCost(initdata);
    let responseTemplates = metadata?.project_response_template || [];
    let defaultResponse = responseTemplates.find((x) => x.default == true);
    setQuoteMessage(defaultResponse?.text);
  }, []);

  useEffect(() => {
    var cost = 0.0;
    for (const key in styleCost) {
      var value = styleCost[key];
      cost += value.patternMakingCost ? parseFloat(value.patternMakingCost) : 0;
      cost += value.sampleCost ? parseFloat(value.sampleCost) : 0;
      cost += value.preProductionCost ? parseFloat(value.preProductionCost) : 0;
      cost += (value.unitCost ? parseFloat(value.unitCost) : 0) * value.quantity;
    }
    cost += additionalCost ? parseFloat(additionalCost) : 0;
    if (cost > 0) setQuotePrice(cost.toFixed(2));
    else setQuotePrice("TBD");
  }, [styleCost, additionalCost]);

  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  function GetDesc(subject, value) {
    return (
      "<div class='grid grid-cols-2 gap-0 nowrap'><div className='whitespace-nowrap'><b>" +
      subject +
      ":</b></div><div className='text-right whitespace-nowrap'>" +
      value +
      "</div></div>"
    );
  }

  const sendQuote = async () => {
    if (!quoteMessage) {
      toast.error(`Please provide inquire message!`);
      return;
    }
    var txtmsg = quoteMessage;
    var desc = "";
    for (var product of selectedProject.products) {
      var value = styleCost[product.title];
      if (
        value.patternMakingCost ||
        value.sampleCost ||
        value.preProductionCost ||
        value.unitCost
      ) {
        desc += GetDesc("Style " + product.title, "");
        if (value.patternMakingCost)
          desc += GetDesc(
            "&nbsp;&nbsp;&nbsp;Pattern Making Cost",
            formatter.format(value.patternMakingCost)
          );
        if (value.sampleCost)
          desc += GetDesc("&nbsp;&nbsp;&nbsp;Sample Cost", formatter.format(value.sampleCost));
        if (value.preProductionCost)
          desc += GetDesc(
            "&nbsp;&nbsp;&nbsp;Pre-production Cost",
            formatter.format(value.preProductionCost)
          );
        if (value.unitCost)
          desc += GetDesc(
            "&nbsp;&nbsp;&nbsp;Unit Production Cost(*" + value.quantity + ")",
            formatter.format(value.unitCost)
          );
      }
    }
    if (additionalCost) desc += GetDesc("Additional Cost", formatter.format(additionalCost));
    desc += GetDesc(
      "Estimated Total Cost",
      quotePrice == "TBD" ? quotePrice : formatter.format(quotePrice)
    );
    if (startDate)
      desc += GetDesc("Estimated Start Date", new Date(startDate).toISOString().slice(0, 10));
    if (endDate)
      desc += GetDesc("Estimated End Date", new Date(endDate).toISOString().slice(0, 10));
    var emailmsg =
      "Estimated Total Cost: " +
      (quotePrice == "TBD" ? quotePrice : formatter.format(quotePrice)) +
      "<br/>" +
      txtmsg.replaceAll("\n", "<br/>");
    api.project
      .updateResponse({ id: selectedProject.id, message: emailmsg })
      .then(() => {
        toast.success(`Send quote to project ${selectedProject.name} successfully!`);
      })
      .catch((err) => toast.error(`Send quote to project ${selectedProject.name} failed!`));

    api.favorites
      .create({ resource_id: selectedProject.id, resource_type: "project" })
      .then(() => {})
      .catch((err) => console.log(err));

    try {
      const { data } = await api.chatroom.addChatRoom({
        userids: [selectedProject.owner_id],
        regardingid: selectedProject.id,
      });
      await api.chatroom.sendmessage(data.id, { text: txtmsg, type: 0, desc: desc });
      for (const file of uploadFiles) {
        var file2 = new File([file], nanoid() + "_" + file.name, { type: file.type });
        console.log(file, file2);
        const url = await api.uploads.create([file2]).then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => url);
          return uploaded;
        });
        if (url && url.length == 1) {
          await api.chatroom.sendmessage(data.id, {
            text: file.name,
            type: 1,
            url: url[0],
            size: file.size,
          });
        }
      }
      setChatRoomId({ id: data.id, bid: data.id });
    } catch (err) {
      toast.error(`Send quote message ${selectedProject.name} failed!`);
      console.log(err);
    }
  };
  console.log("selectedProject.products", selectedProject.products);

  const handleCloseTemplateMenu = () => setTemplateMenuVisible(false);
  const TemplateMenu = () => (
    <Menu
      id="response-template-menu"
      anchorEl={templateMenuVisible}
      open={Boolean(templateMenuVisible)}
      onClose={handleCloseTemplateMenu}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      {responseTemplates.map((x) => (
        <MenuItem
          onClick={() => {
            setQuoteMessage(x.text);
            setEditMessage(false);
            handleCloseTemplateMenu();
          }}
        >
          <SuiTypography variant="body1" textAlign="center">
            {x.title}
          </SuiTypography>
        </MenuItem>
      ))}
    </Menu>
  );

  const handleCreateTemplate = (data) => {
    if (!metadata["project_response_template"]) {
      metadata["project_response_template"] = [];
    }
    let newMeta = { ...metadata };
    let temp = {
      id: nanoid(),
      title: data?.["title"],
      text: data?.["text"],
    };
    newMeta["project_response_template"].push(temp);
    if (newMeta["project_response_template"].length == 1) {
      newMeta["project_response_template"]["default"] = true;
    }

    handleUpdate(id, { metadata: newMeta });
    setCreateTemplateVisible(false);
  };

  return (
    <Card className={`overflow-hidden cardstyle h-fit p-2`}>
      <SuiBox ml={0.5} lineHeight={0} display="inline-block">
        <SuiTypography variant="h5" fontWeight="bold" textTransform="capitalize">
          Send Inquiry
        </SuiTypography>
      </SuiBox>
      <SuiBox
        ml={0.5}
        display="flex"
        flexDirection="column"
        justifyContent="flex-begin"
        height="100%"
      >
        {selectedProject.products.map((product) => {
          return (
            <SuiBox>
              <SuiBox mt={1} lineHeight={0} display="inline-block">
                <SuiTypography className="whitespace-nowrap" component="label" variant="h6">
                  Style {product.title}:
                </SuiTypography>
              </SuiBox>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <SuiBox>
                    <SuiBox lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: "1",
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        Pattern Making Cost:
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput
                      icon={{
                        direction: "left",
                        component: <AttachMoneyIcon fontSize="small" />,
                      }}
                      size="small"
                      type="number"
                      className={classes.input}
                      value={styleCost[product.title]?.patternMakingCost}
                      onChange={(e) => {
                        var copy = { ...styleCost };
                        copy[product.title] = {
                          ...copy[product.title],
                          patternMakingCost: e.target.value,
                        };
                        setStyleCost(copy);
                      }}
                      onFocus={(event) => {
                        event.target.select();
                      }}
                    />
                  </SuiBox>
                </Grid>
                <Grid item xs={6}>
                  <SuiBox>
                    <SuiBox lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: "1",
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        Sample Cost:
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput
                      icon={{
                        direction: "left",
                        component: <AttachMoneyIcon fontSize="small" />,
                      }}
                      placeholder=""
                      size="small"
                      type="number"
                      className={classes.input}
                      value={styleCost[product.title]?.sampleCost}
                      onChange={(e) => {
                        var copy = { ...styleCost };
                        copy[product.title] = {
                          ...copy[product.title],
                          sampleCost: e.target.value,
                        };
                        setStyleCost(copy);
                      }}
                      onFocus={(event) => {
                        event.target.select();
                      }}
                    />
                  </SuiBox>
                </Grid>
                <Grid item xs={6}>
                  <SuiBox>
                    <SuiBox lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: "1",
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        Pre-production Cost:
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput
                      icon={{
                        direction: "left",
                        component: <AttachMoneyIcon fontSize="small" />,
                      }}
                      placeholder=""
                      size="small"
                      type="number"
                      className={classes.input}
                      value={styleCost[product.title]?.preProductionCost}
                      onChange={(e) => {
                        var copy = { ...styleCost };
                        copy[product.title] = {
                          ...copy[product.title],
                          preProductionCost: e.target.value,
                        };
                        setStyleCost(copy);
                      }}
                      onFocus={(event) => {
                        event.target.select();
                      }}
                    />
                  </SuiBox>
                </Grid>
                <Grid item xs={6}>
                  <SuiBox>
                    <SuiBox lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: "1",
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        Unit Production Cost (Quantity: *
                        {product.style?.quantity ? product.style.quantity : 0}):
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput
                      icon={{
                        direction: "left",
                        component: <AttachMoneyIcon fontSize="small" />,
                      }}
                      placeholder=""
                      size="small"
                      type="number"
                      className={classes.input}
                      value={styleCost[product.title]?.unitCost}
                      onChange={(e) => {
                        var copy = { ...styleCost };
                        copy[product.title] = { ...copy[product.title], unitCost: e.target.value };
                        setStyleCost(copy);
                      }}
                      onFocus={(event) => {
                        event.target.select();
                      }}
                    />
                  </SuiBox>
                </Grid>
              </Grid>
            </SuiBox>
          );
        })}
        <SuiBox mt={1} lineHeight={0} display="inline-block">
          <SuiTypography component="label" variant="h6" fontWeight="bold">
            Summary:
          </SuiTypography>
        </SuiBox>
        <Grid container spacing={1}>
          {selectedProject.products.length > 0 && (
            <Grid item xs={6}>
              <SuiBox>
                <SuiBox lineHeight={0} display="inline-block">
                  <SuiTypography
                    component="label"
                    variant="caption"
                    fontWeight=""
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: "1",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    Additional Cost:
                  </SuiTypography>
                </SuiBox>
                <SuiInput
                  icon={{
                    direction: "left",
                    component: <AttachMoneyIcon fontSize="small" />,
                  }}
                  size="small"
                  type="number"
                  className={classes.input}
                  value={additionalCost}
                  onChange={(e) => {
                    setAdditionalCost(e.target.value);
                  }}
                  onFocus={(event) => {
                    event.target.select();
                  }}
                />
              </SuiBox>
            </Grid>
          )}
          <Grid item xs={6}>
            <SuiBox>
              <SuiBox lineHeight={0} display="inline-block">
                <SuiTypography
                  component="label"
                  variant="caption"
                  fontWeight=""
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "1",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  Estimated Total Cost:
                </SuiTypography>
              </SuiBox>
              <SuiInput
                disabled={selectedProject.products.length > 0}
                icon={{
                  direction: "left",
                  component: <AttachMoneyIcon fontSize="small" />,
                }}
                placeholder=""
                size="small"
                className={classes.input}
                value={quotePrice}
                onChange={(e) => {
                  setQuotePrice(e.target.value);
                }}
                onFocus={(event) => {
                  event.target.select();
                }}
              />
            </SuiBox>
          </Grid>
        </Grid>
        <Grid mt={0.1} container spacing={1}>
          <Grid item xs={6}>
            <SuiBox>
              <SuiBox lineHeight={0} display="inline-block">
                <SuiTypography component="label" variant="caption" fontWeight="">
                  Estimated Start Date:
                </SuiTypography>
              </SuiBox>
              <SuiDatePicker value={startDate} onChange={setStartDate} />
            </SuiBox>
          </Grid>
          <Grid item xs={6}>
            <SuiBox>
              <SuiBox lineHeight={0} display="inline-block">
                <SuiTypography component="label" variant="caption" fontWeight="">
                  Estimated End Date:
                </SuiTypography>
              </SuiBox>
              <SuiDatePicker value={endDate} onChange={setEndDate} />
            </SuiBox>
          </Grid>
        </Grid>
        <SuiBox my={1} lineHeight={0} display="flex" justifyContent="space-between">
          <SuiTypography component="label" variant="h6" fontWeight="bold" required>
            Message:
          </SuiTypography>
          <SuiBox display="flex" gap={1}>
            {responseTemplates && responseTemplates.length > 0 ? (
              <SuiBox
                display="flex"
                alignItems="center"
                sx={{ cursor: "pointer", zIndex: 2 }}
                onClick={(e) => {
                  setTemplateMenuVisible(e.target);
                }}
              >
                <SuiTypography
                  variant="body1"
                  color="dark"
                  sx={{ cursor: "pointer", zIndex: 2 }}
                  verticalAlign="middle"
                >
                  Template
                </SuiTypography>
                <KeyboardArrowDownIcon fontSize="small" />
              </SuiBox>
            ) : null}
            <SuiBox display="flex" alignItems="center" sx={{ zIndex: 2 }}>
              <SuiButton
                variant="contained"
                color="dark"
                sx={{
                  minHeight: 24,
                  padding: "0px 8px",
                  minWidth: 42,
                  fontSize: 12,
                  textTransform: "capitalize",
                }}
                onClick={(e) => {
                  setCreateTemplateVisible(true);
                }}
              >
                <AddIcon fontSize="small" />
                Add
              </SuiButton>
            </SuiBox>
          </SuiBox>
          <TemplateMenu />
        </SuiBox>
        {!editMessage ? (
          <Paper elevation={3} variant="outlined" sx={{ px: 2, py: 1 }}>
            <SuiBox display="flex" gap={1}>
              <SuiTypography sx={{ flexGrow: 1 }}>{quoteMessage}</SuiTypography>
              <SuiBox minWidth={40}>
                <SuiButton
                  variant="contained"
                  color="text"
                  sx={{
                    minHeight: 24,
                    padding: "0px 8px",
                    minWidth: 42,
                    fontSize: 12,
                    textTransform: "capitalize",
                  }}
                  onClick={() => setEditMessage(true)}
                  size="small"
                >
                  Edit
                </SuiButton>
              </SuiBox>
            </SuiBox>
          </Paper>
        ) : (
          <SuiInput
            sx={{ minWidth: "480px" }}
            value={quoteMessage}
            minRows={5}
            maxRows={10}
            multiline
            onChange={(e) => setQuoteMessage(e.target.value)}
            onBlur={(event) => {
              setEditMessage(false);
            }}
          />
        )}
        <SuiBox mt={1} lineHeight={0} display="inline-block">
          <SuiTypography component="label" variant="h6" fontWeight="bold">
            Attachments:
          </SuiTypography>
        </SuiBox>
        <DropZone files={uploadFiles} setfiles={setUploadFiles} />
        <DialogActions>
          {chatroomId && (
            <SuiButton
              size="small"
              className="small:px-4 medium:px-6 whitespace-nowrap"
              onClick={() => {
                setChatRoomId({ id: chatroomId, bid: chatroomId });
              }}
              color="secondary"
            >
              Cancel
            </SuiButton>
          )}
          <SuiButton
            size="small"
            className="small:px-4 medium:px-6 whitespace-nowrap"
            onClick={() => {
              sendQuote();
            }}
            color="dark"
          >
            Send Inquiry
          </SuiButton>
        </DialogActions>
      </SuiBox>
      {/**create template */}
      {createTemplateVisible ? (
        <CreateResponseTemplatePrompt
          visible={createTemplateVisible}
          handleClose={() => setCreateTemplateVisible(false)}
          handleOk={handleCreateTemplate}
        />
      ) : null}
    </Card>
  );
};

export default SendQuoteMessage;
